import React, { FC } from "react";
import { StyledMuiButton } from './styles';

export type Props = {
  to?: string;
  children?: React.ReactNode;
  component?: React.ReactNode;
  exact?: boolean;
};

const ToolbarMenuItem: FC<Props> = (props) => {
  const MuiProps = {
    ...props
  };

  return (
    <StyledMuiButton {...MuiProps} />
  );
};

export default ToolbarMenuItem;
